import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import LinkButton from 'flarum/common/components/LinkButton';
import UserPage from 'flarum/forum/components/UserPage';
export default function addProfilePage() {
  extend(UserPage.prototype, 'navItems', function (items) {
    var _this$user;
    if (!((_this$user = this.user) != null && _this$user.usernameHistory())) return;
    items.add('username-requests', m(LinkButton, {
      icon: "fas fa-user-edit",
      href: app.route('username_history', {
        username: this.user.slug()
      })
    }, app.translator.trans('fof-username-request.forum.user.name_history_link')));
  });
}
flarum.reg.add('fof-username-request', 'forum/extenders/addProfilePage', addProfilePage);